import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'indianDate',
    standalone: true,
})
export class IndianDatePipe implements PipeTransform {
    transform(value: any): string {
        if (!value) return '';
        return moment(value).utcOffset('-05:30').format('DD-MM-YYYY');
    }
}
